export const store = {
    title: "Store",
    bangkok: "Bangkok",
    provincial: 'Provincial',
    airport: 'Airport',
    nearby: 'Nearby',

    km: 'km.',
    get_direction: 'Get direction',
    tel: 'Tel :',
    call_now: 'Call now',
    service: 'Service'
};